<p>delete-predefined-parameter works!</p>
